import React, { useContext, useEffect, useState } from "react";
import UserList from "../Components/UserList";
import { useQuery } from "@tanstack/react-query";
import { ApiCallGateway } from "../Network/apiCallGateway";
import { Form, Input } from "reactstrap";
import { LuSearch } from "react-icons/lu";
import { DataContext } from "../context/DataContext";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Pagination from "../Components/Pagination/Pagination";
function Users() {
  const history = useHistory();
  const { setAdminViewUser } = useContext(DataContext);
  const [searchString, setSearchString] = useState("");
  const [page, setpage] = useState(1);
  const {
    isLoading,
    error,
    data: userList,
    refetch,
  } = useQuery({
    queryKey: ["userList" + page],
    queryFn: async () => {
      const res = await ApiCallGateway.user.allUsers(
        searchString,
        12,
        page
      );
      if (res?.status === 200) {
        return res?.data;
      } else {
        return [];
      }
    },
  });

  // console.log(userList);

  const updateUser = async (body, userid) => {
    console.log(body, userid);
    const user = await ApiCallGateway.user.updateUser(body, userid);
    console.log(user);
    refetch();
  };

  useEffect(() => {
    refetch();
  }, [page, searchString]);

  return (
    <div style={{ marginTop: 5 }}>
      <Form className="formWrap">
        <div className="formElmWrap">
          <Input
            id="search"
            name="search"
            placeholder="Enter Search String"
            type="text"
            autoComplete="off"
            // autoFocus
            onChange={(e) => setSearchString(e.target.value)}
          />
          <span
            className="formIcon plus"
            // onClick={() => setSearchBox(true)}
          >
            <LuSearch />
          </span>
        </div>
      </Form>

      <div className="accessTable" style={{}}>
        <table className="table">
          <tbody styles={{ height: "500px", overflowY: "scroll" }}>
            <tr>
              <td></td>
              <td>Designation</td>
              <td>Admin</td>
              <td>Active</td>
              <td></td>
            </tr>
            {userList?.data &&
              userList?.data?.map((item) => {
                return (
                  <UserList
                    key={item?._id}
                    user={item}
                    onUpdate={(body, id) => updateUser(body, id)}
                    onViewProfile={() => {
                      setAdminViewUser(item);
                      history.push("/created");
                    }}
                  />
                );
              })}
          </tbody>
        </table>
        <Pagination
          totalPost={userList?.total}
          postsPerPage={12}
          setCurrentPage={(e) => setpage(e)}
          currentPage={page}
        />
      </div>
    </div>
  );
}

export default Users;
